import type { Suggestion, ContentPage } from '../types'
import { WIDGET_CONFIG } from '../config'

interface EmptyStateProps {
  suggestions: Suggestion[]
  onSelectSuggestion: (label: string) => void
  recentPages?: ContentPage[]
}

export function EmptyState({ suggestions, onSelectSuggestion, recentPages }: EmptyStateProps) {
  return (
    <div class="spotlight-empty">
      {recentPages && recentPages.length > 0 && (
        <>
          <div class="spotlight-empty-label">{WIDGET_CONFIG.copy.recentPagesLabel}</div>
          {recentPages.map((page) => (
            <div
              key={page.id}
              class="spotlight-recent-chip"
              onClick={() => { window.location.href = page.url }}
              role="option"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: var(--spotlight-text-muted); flex-shrink: 0; margin-top: 2px;">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <div class="spotlight-recent-text">
                <span class="spotlight-recent-title">{page.title}</span>
                <span class="spotlight-recent-summary">{page.summary.slice(0, 80)}</span>
              </div>
              <span class="spotlight-suggestion-arrow">›</span>
            </div>
          ))}
        </>
      )}

      {suggestions.length > 0 && (
        <>
          <div class="spotlight-empty-label">{WIDGET_CONFIG.copy.suggestionsLabel}</div>
          {suggestions.map((s) => (
            <div
              key={s.id}
              class="spotlight-suggestion-chip"
              onClick={() => onSelectSuggestion(s.label)}
              role="option"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: var(--spotlight-text-muted); flex-shrink: 0;">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              {s.label}
              <span class="spotlight-suggestion-arrow">›</span>
            </div>
          ))}
        </>
      )}
    </div>
  )
}
